<template>
  <c-modal
    v-model="modal"
    size="md"
    centered
    no-fade
    :tag="false"
    :title="food.IsAvailable ? 'Make Item Unavailable Confirmation' : 'Make Item Available Confirmation'"
    :confirm-label="food.IsAvailable ? 'Yes, Make Item Unavailable' : 'Yes, Make Item Available'"
    cancel-label="No, Never mind"
    :progressing="progressing"
    @submit="submit"
    @show="showModal"
  >
    <template>
      Are you sure you want to make {{food.Name}} {{food.IsAvailable ? 'unavailable' : 'available'}} ?
      <div class="mt-3">
        <b-form-checkbox
          v-model="changeAll"
          :value="true"
          :unchecked-value="false"
        >
          Make all "{{food.Name}}" {{food.IsAvailable ? 'unavailable' : 'available'}} in other categories and menus.
        </b-form-checkbox>
      </div>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "../../../../shared/Cmodal";
  export default {
    name: "StatusConfirmation",
    components: {CModal},
    props: {
      progressing: {
        type: Boolean,
        default: false
      },
      value: {
        required: true
      },
      food: {
        required: true,
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        changeAll: false
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      showModal () {
        this.changeAll = false
      },
      submit () {
        this.$emit('refresh', {food: this.food, changeAll: this.changeAll})
      }
    }
  }
</script>

<style scoped>

</style>
